<template>
    <AuthenticatedShell full-bleed-brand>
        <div
            class="ea-config-layout tp-main-layout tp-main-app"
            :class="{ 'tp-main-app--thread': historyMessages.length > 0 }"
        >
            <div class="ea-config-scroll tp-main-ea-scroll">
                <div class="wizard tp-main-wizard">
                    <section class="section command-list primary tp-main-command">
                        <div class="command-list-header agents-hero" v-if="!hasMessage && historyMessages.length == 0">
                                                <div class="agents-hero-inner">
                                                    <img
                                                        class="agents-hero-logo"
                                                        src="/assets/images/logo/logo-escolarai-b.svg"
                                                        alt=""
                                                    />
                                                    <div class="agents-hero-copy">
                                                        <h2 class="agents-hero-title">Agentes de apoio</h2>
                                                        <p class="agents-hero-lead">
                                                            Escolha um agente para padrões prontos (atividades, avisos, comunicação).
                                                            Os principais aparecem aqui; a lista completa fica em uma tela dedicada.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>

                                            <!--Content Section — preview dos agentes (CRUD em evolução) -->

                                            <div
                                                class="command-list-content agents-home"
                                                v-if="!hasMessage && historyMessages.length == 0"
                                            >
                                                <div class="agents-toolbar">
                                                    <span class="agents-preview-label">Em destaque</span>
                                                    <router-link class="agents-link-all" to="/agentes">
                                                        Ver todos os agentes
                                                    </router-link>
                                                </div>

                                                <div class="agents-grid">
                                                    <article
                                                        v-for="crew in featuredAgents"
                                                        :key="crew.id"
                                                        class="agent-card"
                                                        role="button"
                                                        tabindex="0"
                                                        @click="getParameters(crew.id, crew)"
                                                        @keyup.enter="getParameters(crew.id, crew)"
                                                    >
                                                        <div class="agent-card-top">
                                                            <span
                                                                class="agent-badge"
                                                                :data-tone="inferCategory(crew).tone"
                                                            >
                                                                {{ inferCategory(crew).label }}
                                                            </span>
                                                            <span class="agent-card-meta">#{{ crew.id }}</span>
                                                        </div>
                                                        <h3 class="agent-card-title">{{ crew.name }}</h3>
                                                        <p class="agent-card-desc">
                                                            {{ excerpt(crew.description, 130) }}
                                                        </p>
                                                        <div class="agent-card-footer">
                                                            <span>Parâmetros</span>
                                                            <svg class="agent-card-chevron" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                                                <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </div>
                                                    </article>
                                                </div>

                                                <p v-if="hasMoreAgents" class="agents-more-hint">
                                                    +{{ moreAgentsCount }} na lista completa.
                                                    <router-link to="/agentes">Abrir todos</router-link>
                                                </p>
                                            </div>

                                            <!--Message Conversation List -->
                                            
                                        <section class="section message-list primary tp-chat-thread" v-if="historyMessages.length != 0" ref="messageList">

                                            <!--Content Section-->

                                            <div class="message-list-content">
                                                <div class="content-wrapper primary tp-chat-feed">
                                                    <article
                                                        v-for="(message, index) in historyMessages"
                                                        :key="index"
                                                        class="tp-chat-turn"
                                                        :aria-label="'Mensagem ' + (index + 1)"
                                                    >
                                                        <div class="wrapper-inner asking tp-chat-user">
                                                            <div class="content-text">
                                                                <div class="desc">
                                                                    <p>{{ message.content }}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="wrapper-inner answer tp-chat-assistant">
                                                            <div class="tp-chat-assistant-head">
                                                                <div class="content-icon">
                                                                    <div class="icon">
                                                                        <img
                                                                            src="/assets/images/logo/logo-escolarai-b.svg"
                                                                            alt=""
                                                                        />
                                                                    </div>
                                                                    <div class="value-text">
                                                                        <div class="title">
                                                                            <h3>Chat de Dúvidas</h3>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="content-value tp-chat-assistant-card">
                                                                <div
                                                                    v-if="responseRunIa[index]?.title"
                                                                    class="value-caption tp-chat-assistant-caption"
                                                                >
                                                                    <div class="caption">
                                                                        <span v-html="responseRunIa[index]?.title"></span>
                                                                    </div>
                                                                </div>
                                                                <div class="value-text tp-chat-prose">
                                                                    <p v-html="responseRunIa[index]?.output"></p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </article>
                                                </div>
                                            </div>
                                            <div class="loading-dots" v-if="showLoading">
                                                <div class="loading-dots-content">
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                    <span class="dot"></span>
                                                </div>
                                            </div>
                                        </section>
                    </section>
                </div>
            </div>

            <section class="section message-box primary tp-main-composer">
                <div class="message-box-content">
                    <div class="content-form">
                        <div class="form-group">
                            <div class="form-input">
                                <span class="input">
                                    <input
                                        type="search"
                                        v-model="hasMessage"
                                        class="form-control"
                                        placeholder="Escreva a tarefa que precisa ser feita"
                                        @keyup.enter="getResponseRunIa"
                                    />
                                </span>
                                <span class="button">
                                    <button
                                        type="button"
                                        class="btn btn-block btn-form"
                                        @click="getResponseRunIa"
                                        :disabled="!hasMessage || showLoading"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M4.79495 5.12264C3.06804 4.50448 1.48934 6.34298 2.36147 7.95659L4.91684 12.6845L2.45796 16.9331C1.53522 18.5274 3.07596 20.4157 4.82302 19.8317L20.5763 14.5658C22.3773 13.9637 22.4041 11.4259 20.6163 10.7859L4.79495 5.12264ZM17.2389 11.7012L4.12092 7.00564L6.65881 11.7012H17.2389ZM6.63923 13.7012L4.18895 17.9349L16.854 13.7012H6.63923Z"
                                                fill="white"
                                            />
                                        </svg>
                                    </button>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="content-caption">
                        <div class="caption">
                            <span>
                                Lembre-se de sempre revisar! Os textos são gerados por inteligência artificial e podem
                                conter informações imprecisas.
                            </span>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </AuthenticatedShell>
</template>

<script>
    import AuthenticatedShell from '@/components/layout/AuthenticatedShell.vue';
    import parameters from '@/utils/parameters.js';
    import { mapState, mapActions } from 'vuex';
    import crews from '@/utils/crews';
    import users from '@/utils/users';
    import order from '@/utils/order';
    import { inferAgentCategory, excerpt } from '@/utils/agentDisplay';

    export default {
        components: {
            AuthenticatedShell
        },
        data() {
            return {
                hasMessage: '',
                menssageCrew: '',
                crews: [],
                userData: {
                    name: '',
                    email: '',
                    password: ''
                },
                parameters: [],
                responseRunIa: [],
                chatContainer: null,
                submitedMessage: false,
                historyMessages: [],
                showLoading: false
            };
        },
        computed: {
            ...mapState(['token', 'user', 'currentCrew', 'currentRunIa', 'userInfoData']),
            previewLimit() {
                return 6;
            },
            featuredAgents() {
                return Array.isArray(this.crews) ? this.crews.slice(0, this.previewLimit) : [];
            },
            hasMoreAgents() {
                return this.crews.length > this.previewLimit;
            },
            moreAgentsCount() {
                return Math.max(0, this.crews.length - this.previewLimit);
            }
        },
        mounted() {
            this.getCrews();
            this.getUserData();
        },
        updated() {
            this.scrollToBottom();
        },
        watch: {
            hasMessage() {
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            },
            responseRunIa: {
                handler() {
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                },
                deep: true
            }
        },
        methods: {
            ...mapActions(['storeIsVisibleSideBarGenericModal', 'storeFieldsModalGeneric', 'storeCurrentCrew', 'storeUserInfoData', 'storeCrewsList']),
            inferCategory(crew) {
                return inferAgentCategory(crew);
            },
            excerpt,
            async getCrews() {
                try {
                    const response = await crews.getCrews(this.token);
                    this.crews = response;
                    this.storeCrewsList({ crewsList: response });
                } catch (error) {
                    console.error('Erro ao buscar tripulantes:', error);
                }
            },
            async getUserData() {
                try {
                    const response = await users.getUsersById(this.token, this.user.user_id);
                    this.storeUserInfoData({ userInfoData: response });
                } catch (error) {
                    console.error('Erro ao buscar usuário:', error);
                }
            },
            async getParameters(id, crew) {
                try {
                    const response = await parameters.getParameters(this.token, id);
                    this.storeIsVisibleSideBarGenericModal({ isVisibleSideBarGenericModal: true });
                    this.storeFieldsModalGeneric({ fields: response });
                    this.storeCurrentCrew({ currentCrew: crew });
                    this.parameters = response;
                } catch (error) {
                    console.error('Erro ao buscar parâmetros:', error);
                }
            },
            logout() {
                this.storeToken({ token: null });
                this.storeRefreshToken({ refreshToken: null });
                this.$router.push('/login');
            },
            async getResponseRunIa() {
                if (!this.hasMessage || this.showLoading) return;
                
                this.historyMessages.push({
                    content: this.hasMessage
                });
                const currentMessage = this.hasMessage;
                this.hasMessage = '';
                this.submitedMessage = true;
                this.showLoading = true;
                
                const payload = {
                    "id": 0,
                    "type_engine":  1,
                    "crew_id": this.user.crew_id,
                    "request_type": 1,
                    "status": 0,
                    "parameters": [
                        {
                            "type": 1,
                            "property": "request",
                            "value": currentMessage
                        }
                    ]
                };
                try {
                    const response = await order.order(payload, this.token);
                    if (response?.output) {
                        response.output = response.output
                            .replace(/^# (.*$)/gm, '<h1>$1</h1>')
                            .replace(/^## (.*$)/gm, '<h2>$1</h2>')
                            .replace(/^### (.*$)/gm, '<h3>$1</h3>')
                            .replace(/^#### (.*$)/gm, '<h4>$1</h4>')
                            .replace(/^##### (.*$)/gm, '<h5>$1</h5>')
                            .replace(/^###### (.*$)/gm, '<h6>$1</h6>')
                            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
                            .replace(/\*(.*?)\*/g, '<em>$1</em>')
                            .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2">$1</a>')
                            .replace(/`([^`]+)`/g, '<code>$1</code>')
                            .replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>')
                            .replace(/^> (.*$)/gm, '<blockquote>$1</blockquote>')
                            .replace(/^- (.*$)/gm, '<li>$1</li>')
                            .replace(/\n/g, '<br> ');
                    }
                    this.responseRunIa.push(response);
                
                    this.showLoading = false;
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                } catch (error) {
                    console.error('Erro ao buscar resposta da IA:', error);
                    this.showLoading = false;
                }
            },
            scrollToBottom() {
                const messageList = this.$refs.messageList;
                if (messageList) {
                    messageList.scrollTop = messageList.scrollHeight;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
/* Paleta mais suave (menos contraste agressivo que o verde-lima #ceff1f) */
$tp-accent: #b4c4a8;
$tp-accent-muted: #9daa92;
$tp-accent-border: rgba(180, 196, 168, 0.38);
$tp-accent-fill: rgba(180, 196, 168, 0.09);
$tp-accent-fill-hover: rgba(180, 196, 168, 0.14);
$tp-surface-elevated: #1e1f24;

/* Mesmo “stack” que config/agentes: layout + scroll + compositor */
.ea-config-layout.tp-main-layout {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
}

.ea-config-scroll.tp-main-ea-scroll {
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    box-sizing: border-box;
}

.tp-main-app--thread .ea-config-scroll.tp-main-ea-scroll {
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.tp-main-wizard,
.tp-main-command {
    width: 100%;
    max-width: 100%;
}

/* Com fio ativo: coluna flex para a lista ocupar a altura útil (scroll só no .tp-chat-thread) */
.tp-main-app--thread .tp-main-wizard {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
}

.tp-main-app--thread .tp-main-command.section.command-list.primary {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
}

.tp-main-composer {
    flex-shrink: 0;
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0.5rem clamp(0.65rem, 1.5vw, 1rem) 0.65rem !important;
    background: #0d0e11 !important;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.tp-main-composer .message-box-content {
    max-width: 48rem;
    width: 100% !important;
    margin-left: auto !important;
    margin-right: auto !important;
}

/* Compositor: botão e placeholder menos saturados que o azul global #34A5E4 */
.tp-main-composer :deep(.form-input > span.button .btn-form) {
    background-color: #4a7f96 !important;
    transition: background-color 0.15s ease, opacity 0.15s ease;
}
.tp-main-composer :deep(.form-input > span.button .btn-form:hover:not(:disabled)) {
    background-color: #5d92a8 !important;
}
.tp-main-composer :deep(.form-input > span.button .btn-form:disabled) {
    opacity: 0.45;
}
.tp-main-composer :deep(.form-control::placeholder) {
    color: #8b929e !important;
}
.tp-main-composer :deep(.content-caption .caption > span) {
    color: #8b939e !important;
}

.agents-hero {
    margin-bottom: 1rem;
    text-align: left !important;
}
.agents-hero-inner {
    display: flex;
    align-items: flex-start;
    gap: 1rem;
    padding: 0.25rem 0.35rem 0.5rem;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.agents-hero-logo {
    width: 48px;
    height: auto;
    flex-shrink: 0;
}
.agents-hero-title {
    margin: 0 0 0.35rem;
    font-size: clamp(1.35rem, 2.5vw, 1.75rem);
    font-weight: 600;
    color: #e8eaef;
    letter-spacing: -0.02em;
}
.agents-hero-lead {
    margin: 0;
    max-width: 40rem;
    color: #a3aab8;
    font-size: 14px;
    line-height: 1.55;
}

.agents-home {
    width: 100%;
    max-width: 100%;
    padding: 0 0.15rem 0.5rem;
    box-sizing: border-box;
}

.agents-toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 1rem;
    margin-bottom: 0.85rem;
    flex-wrap: wrap;
    width: 100%;
}
.agents-preview-label {
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #8b939e;
}
.agents-link-all {
    margin-left: auto;
    font-size: 14px;
    font-weight: 600;
    color: $tp-accent;
    text-decoration: none;
    padding: 0.35rem 0.65rem;
    border-radius: 999px;
    border: 1px solid $tp-accent-border;
    background: $tp-accent-fill;
    transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.agents-link-all:hover {
    background: $tp-accent-fill-hover;
    border-color: rgba(180, 196, 168, 0.5);
    color: #c8d4bc;
}

.agents-grid {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(auto-fill, minmax(240px, 300px));
    justify-content: start;
    gap: 0.85rem;
}

.agent-card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 168px;
    padding: 1rem 1rem 0.65rem;
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.06);
    background: linear-gradient(165deg, $tp-surface-elevated 0%, #18191d 100%);
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
    cursor: pointer;
    text-align: left;
    transition: border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}
.agent-card:hover,
.agent-card:focus {
    outline: none;
    border-color: $tp-accent-border;
    transform: translateY(-1px);
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.22);
}
.agent-card:focus-visible {
    box-shadow: 0 0 0 2px rgba(180, 196, 168, 0.28);
}

.agent-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    margin-bottom: 0.65rem;
}
.agent-card-meta {
    font-size: 11px;
    color: #6f7784;
    font-variant-numeric: tabular-nums;
}

.agent-badge {
    display: inline-block;
    padding: 0.2rem 0.55rem;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.02em;
    border: 1px solid transparent;
}
.agent-badge[data-tone='blue'] {
    color: #9ecae8;
    background: rgba(120, 155, 185, 0.14);
    border-color: rgba(120, 155, 185, 0.28);
}
.agent-badge[data-tone='amber'] {
    color: #d8c9a4;
    background: rgba(200, 175, 120, 0.12);
    border-color: rgba(200, 175, 120, 0.26);
}
.agent-badge[data-tone='mint'] {
    color: #a8c9b4;
    background: rgba(120, 165, 140, 0.12);
    border-color: rgba(120, 165, 140, 0.24);
}
.agent-badge[data-tone='cyan'] {
    color: #9cc8cf;
    background: rgba(110, 165, 175, 0.12);
    border-color: rgba(110, 165, 175, 0.24);
}
.agent-badge[data-tone='slate'] {
    color: #b8c0cd;
    background: rgba(130, 145, 168, 0.12);
    border-color: rgba(130, 145, 168, 0.22);
}

.agent-card-title {
    margin: 0 0 0.4rem;
    font-size: 1rem;
    font-weight: 600;
    color: #eceef2;
    line-height: 1.3;
}
.agent-card-desc {
    margin: 0 0 auto;
    font-size: 13px;
    line-height: 1.45;
    color: #a3aab8;
    flex: 1 1 auto;
}

.agent-card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.85rem;
    padding-top: 0.55rem;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    font-size: 12px;
    font-weight: 600;
    color: $tp-accent-muted;
    letter-spacing: 0.02em;
}
.agent-card-chevron {
    color: $tp-accent-muted;
    opacity: 0.9;
}

.agents-more-hint {
    margin: 1rem 0 0;
    font-size: 13px;
    color: #818994;
    text-align: left;
}
.agents-more-hint a {
    color: $tp-accent;
    margin-left: 0.25rem;
    font-weight: 600;
    text-decoration: none;
}
.agents-more-hint a:hover {
    color: #c8d4bc;
    text-decoration: underline;
}
</style>
<style lang="scss">
/* Com fio ativo: sem scroll da janela — rolagem só em .tp-chat-thread */
html:has(.tp-main-app--thread),
body:has(.tp-main-app--thread) {
    overflow: hidden;
    height: 100%;
}

/* Compositor: deixa de ser absolute ao centro do page-wrapper (layout antigo) */
.ea-brand-shell .message-box.primary.tp-main-composer {
    position: relative !important;
    left: auto !important;
    bottom: auto !important;
    transform: none !important;
    width: 100% !important;
}
</style>
<style scoped>
.loading-dots {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem 1rem 1.5rem;
}

.loading-dots-content {
    display: flex;
    gap: 8px;
}

.dot {
    width: 8px;
    height: 8px;
    background-color: rgba(140, 175, 190, 0.65);
    border-radius: 50%;
    animation: fade 1.5s infinite;
}

.dot:nth-child(2) {
    animation-delay: 0.5s;
}

.dot:nth-child(3) {
    animation-delay: 1s;
}

@keyframes fade {
    0%, 100% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
}

/* Fio do chat: única rolagem vertical, barra oculta (estilo app / Claude) */
.tp-chat-thread {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
}

.tp-chat-thread::-webkit-scrollbar {
    width: 0;
    height: 0;
}

.tp-chat-feed {
    width: 100%;
    margin: 0 auto;
    padding: 0.5rem 0.75rem 2rem;
    box-sizing: border-box;
}

.tp-chat-turn {
    margin-bottom: 1.75rem;
}

.tp-chat-turn:last-child {
    margin-bottom: 0.5rem;
}

/* Utilizador — alinhado à direita, bolha */
.tp-chat-user {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-top: 0.25rem;
}

.tp-chat-user .content-text {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    margin-right: 0;
}

.tp-chat-user .desc {
    max-width: min(88%, 34rem);
    width: auto;
    margin: 0;
    padding: 0.7rem 1rem;
    background: #2c2d34;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 18px 18px 4px 18px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.16);
}

.tp-chat-user .desc p {
    margin: 0;
    color: #ebecef;
    font-size: 15px;
    line-height: 1.55;
    white-space: pre-wrap;
    word-break: break-word;
}

/* Assistente — cabeçalho + cartão (estilo ChatGPT / Claude) */
.tp-chat-assistant {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 0.5rem;
    margin-top: 1rem;
    width: 100%;
}

.tp-chat-assistant-head .content-icon {
    display: flex;
    align-items: center;
    gap: 0.65rem;
}

.tp-chat-assistant-head .icon img {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: block;
}

.tp-chat-assistant-head .value-text .title h3 {
    margin: 0;
    font-size: 0.9375rem;
    font-weight: 600;
    color: #e8eaef;
    letter-spacing: -0.01em;
}

.tp-chat-assistant-card {
    width: 100%;
    padding: 1rem 1.15rem 1.15rem;
    border-radius: 14px;
    background: #222328;
    border: 1px solid rgba(255, 255, 255, 0.06);
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.03);
}

.tp-chat-assistant-caption {
    margin-bottom: 0.65rem;
}

.tp-chat-assistant-caption .caption {
    font-size: 0.8125rem;
    line-height: 1.45;
    color: #a3aab8;
}

.tp-chat-assistant-caption :deep(span) {
    color: inherit;
}

.tp-chat-prose :deep(p) {
    margin: 0 0 0.85em;
    color: #dfe3ea;
    font-size: 15px;
    line-height: 1.65;
    word-break: break-word;
}

.tp-chat-prose :deep(p:last-child) {
    margin-bottom: 0;
}

.tp-chat-prose :deep(h1),
.tp-chat-prose :deep(h2),
.tp-chat-prose :deep(h3),
.tp-chat-prose :deep(h4) {
    margin: 1.1em 0 0.45em;
    color: #eceef2;
    font-weight: 600;
    line-height: 1.3;
}

.tp-chat-prose :deep(h1:first-child),
.tp-chat-prose :deep(h2:first-child),
.tp-chat-prose :deep(h3:first-child) {
    margin-top: 0;
}

.tp-chat-prose :deep(code) {
    font-size: 0.88em;
    padding: 0.12em 0.35em;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(255, 255, 255, 0.08);
    color: #e2e8f0;
}

.tp-chat-prose :deep(pre) {
    margin: 0.75em 0;
    padding: 0.85rem 1rem;
    border-radius: 10px;
    background: #121316;
    border: 1px solid rgba(255, 255, 255, 0.08);
    overflow-x: auto;
}

.tp-chat-prose :deep(pre code) {
    padding: 0;
    border: none;
    background: transparent;
    font-size: 13px;
    line-height: 1.5;
}

.tp-chat-prose :deep(a) {
    color: #8ec5e0;
    text-decoration: underline;
    text-underline-offset: 2px;
}

.tp-chat-prose :deep(blockquote) {
    margin: 0.65em 0;
    padding-left: 0.85rem;
    border-left: 3px solid rgba(180, 196, 168, 0.4);
    color: #b8c0cc;
}

.tp-chat-prose :deep(li) {
    margin: 0.25em 0;
    color: #dfe3ea;
}

a.content-anchor {
    cursor: pointer;
}
</style>